import React, { useRef, useState } from 'react';

function TextEditor({ setNewText }) {
    const [showToolbar, setShowToolbar] = useState(false);
    const [toolbarPosition, setToolbarPosition] = useState({ x: 0, y: 0 });
    const editorRef = useRef(null);

    const handleTextSelect = () => {
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0 && !selection.isCollapsed) {
            const range = selection.getRangeAt(0);
            const rect = range.getBoundingClientRect();
            setToolbarPosition({ x: rect.left + window.scrollX, y: rect.top + window.scrollY - 40 });
            setShowToolbar(true);
        } else {
            setShowToolbar(false);
        }
    };

    const applyFormat = (tag) => {
        document.execCommand(tag, false, null);
        setShowToolbar(false);
    };

    const handleInput = (e) => {
        setNewText(e.target.innerHTML);
    };

    const insertBookContent = () => {
        const bookContent = document.getElementById('book-content')?.innerHTML;
        if (bookContent) {
            const editor = editorRef.current;
            if (editor) {
                editor.innerHTML = `<p>${bookContent}</p>`;
                setNewText(editor.innerHTML);
            }
        }
    };

    return (
        <div>
            {showToolbar && (
                <div
                    style={{
                        position: 'absolute',
                        top: `${toolbarPosition.y-20}px`,
                        left: `${toolbarPosition.x}px`,
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: '5px',
                        borderRadius: '5px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                    }}
                >
                    <button className="btn m-1 btn-secondary btn-sm" onClick={() => applyFormat('bold')}><b>B</b></button>
                    <button className="btn m-1 btn-secondary btn-sm" onClick={() => applyFormat('italic')}><i>I</i></button>
                    <button className="btn m-1 btn-secondary btn-sm" onClick={() => applyFormat('underline')}><u>U</u></button>
                </div>
            )}
            <button
                type="button"
                onClick={insertBookContent}
                className="btn btn-secondary btn-sm mb-3"
            >
                Upravit kapitolu
            </button>
            <div
                ref={editorRef}
                contentEditable
                onMouseUp={handleTextSelect}
                onKeyUp={handleTextSelect}
                onInput={handleInput}
                style={{
                    border: '1px solid #ccc',
                    padding: '10px',
                    borderRadius: '5px',
                    minHeight: '200px',
                    outline: 'none',
                    marginTop: '20px',
                    marginBottom: '20px',
                }}
            ></div>
        </div>
    );
}

export default TextEditor;
